var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-container"},[_c('el-progress',{staticClass:"m-progress-bar",attrs:{"percentage":_vm.showPercent,"status":"success","text-inside":true,"color":_vm.customColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }